module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vbl-layout-example"
  }, [_c('vbl-row', [_c('vbl-col', [_vm._v("auto")]), _c('vbl-col', [_vm._v("auto")])], 1), _vm._v("\n    栅格间距20px\n    "), _c('vbl-row', {
    attrs: {
      "gutters": "20"
    }
  }, [_c('vbl-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("2")]), _c('vbl-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("2")])], 1), _vm._v("\n    上下左右居中\n    "), _c('vbl-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('vbl-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("2")]), _c('vbl-col', {
    attrs: {
      "cols": "8"
    }
  }, [_vm._v("8")]), _c('vbl-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("2")])], 1), _vm._v("\n    栅格左侧的间隔格数\n    "), _c('vbl-row', [_c('vbl-col', {
    attrs: {
      "cols": "2"
    }
  }, [_vm._v("2")]), _c('vbl-col', {
    attrs: {
      "cols": "2",
      "offset": "8"
    }
  }, [_vm._v("2")])], 1), _vm._v("\n    嵌套\n    "), _c('vbl-row', [_c('vbl-col', [_c('vbl-row', [_c('vbl-col', [_vm._v("auto")]), _c('vbl-col', [_vm._v("auto")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76aeb159","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblLayout/example/vblLayoutExample.vue
// module id = 280
// module chunks = 0